var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4978 0.5C17.7056 0.5 17.8985 0.600183 18.0183 0.765569L18.065 0.840337L21.4994 7.27983L21.5361 7.3676L21.5461 7.4L21.5606 7.46626L21.5686 7.54169L21.5668 7.62689L21.5692 7.57143C21.5692 7.66151 21.5507 7.74731 21.5172 7.82523L21.4925 7.87631L21.4577 7.9334L21.4125 7.99211L11.7977 19.104C11.7119 19.2192 11.5944 19.2952 11.4668 19.3317L11.417 19.3438L11.3336 19.3553L11.2833 19.3571L11.1971 19.3513L11.1242 19.3375L11.0356 19.3085L11.0136 19.298C10.9362 19.2638 10.865 19.2128 10.8056 19.1459L1.1441 7.97969L1.09087 7.9046L1.0498 7.8248L1.02007 7.73969L1.00024 7.62731L1 7.51811L1.01274 7.43351L1.02096 7.39991L1.05001 7.31754L1.07345 7.26894L4.50202 0.840337C4.59978 0.657037 4.77897 0.533943 4.98129 0.506034L5.06924 0.5H17.4978ZM14.6315 8.21429H7.93292L11.2844 16.9229L14.6315 8.21429ZM6.55639 8.21429H3.04553L9.36521 15.5154L6.55639 8.21429ZM19.5189 8.21429H16.0106L13.2052 15.5094L19.5189 8.21429ZM7.87549 1.78486H5.4541L2.71039 6.92857H6.50324L7.87549 1.78486ZM13.3604 1.78486H9.20578L7.83353 6.92857H14.7318L13.3604 1.78486ZM17.1121 1.78486H14.6906L16.0629 6.92857H19.8541L17.1121 1.78486Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/Subscription.c71094eaa2ddd88b28f6d4e51ca8d75d.svg";
export { ForwardRef as ReactComponent };